<!-- popover for group select -->
<ng-template #popoverGroups>
  <input
    type="text"
    id="resource-search"
    placeholder="Search"
    [(ngModel)]="popoverSearch"
    class="textbox inline full small-textbox"
    />
  <br />
  <ul class="group-list">
    @for (
      group of templateGroups
      | filterGroups : popoverSearch
      | orderBy : 'order'
      ; track
      group) {
      <li
        class="take-action-item"
        >
        <div (click)="selectGroup(group)">{{ group.name }}</div>
      </li>
    }
  </ul>
</ng-template>

<div class="modal-content">
  <!-- Header -->
  <div class="modal-header company-modal-header">
    <span>Add Page Template</span>
    <i class="material-icons" data-bs-dismiss="modal" (click)="closeModal()"
      >close</i
      >
    </div>
    <div class="modal-body">
      <form name="templateForm" #templateForm="ngForm">
        <!-- Template form fields -->
        <div class="form-group">
          <div class="row align-items-center">
            <label for="name" class="control-label col-sm-4 required-field"
              >Name</label
              >
              <div class="col-sm-8">
                <input
                  type="text"
                  id="name"
                  name="name"
                  [(ngModel)]="templateName"
                  #name="ngModel"
                  required
              [ngClass]="{
                'invalid-field': name.touched && name.errors?.required
              }"
                  class="form-control vplaybook__form__inputs"
                  />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="container-preview-image" class="control-label col-sm-4"
              >Preview Image</label
              >
              <div class="col-sm-7">
                @if (previewImage) {
                  <a
                    class="remove-image delete-item"
                    (click)="previewImage = null"
                    >
                    <i class="material-icons delete-icon">delete</i></a
                    >
                  }
                  <div id="preview-image-container">
                    <input
                      #fileInputPlaceHolder
                      value=""
                      type="file"
                      class="uploadResource btn"
                      (change)="fileChangeEvent($event)"
                      style="display: none"
                      id="file-in"
                      />
                    <label for="file-in">
                      @if (!previewImage) {
                        <div
                          style="margin-top: 20px"
                          class="cursor-pointer"
                          >
                          <span class="material-icons upload-icon upload-icon-color"
                            >cloud_upload</span
                            >
                            <p style="font-size: 14px; font-weight: bold; margin-top: 4px">
                              Click to upload JPG or PNG image
                            </p>
                          </div>
                        }
                        @if (previewImage) {
                          <img
                src="{{
                  '/api/Assets/Image/' +
                    previewImage.id +
                    '?height=145&ratio=' +
                    devicePixelRatio
                    | loadSecureAssets : true
                    | async
                }}"
                            class="container-preview-image"
                            alt=""
                            onerror="this.src = 'assets/img/loader.gif'"
                            (load)="imageLoaded = true"
                            [hidden]="!imageLoaded"
                            />
                        }
                      </label>
                    </div>
                  </div>
                </div>
                <div id="templateDescription" class="row form-group align-items-center">
                  <label for="e-message" class="control-label col-sm-4"
                    >Description</label
                    >
                    <div class="col-sm-8">
                      <app-rich-text-editor [(ngModel)]="description" name="description">
                      </app-rich-text-editor>
                    </div>
                  </div>
                  @if (profile.role == 'SuperVPlaybookAdmin') {
                    <div class="form-group">
                      <div class="row align-items-center">
                        <label class="control-label col-sm-4">Group</label>
                        <div class="col-sm-8">
                          <select
                            class="form-control"
                            name="groupId"
                            (change)="groupChange($event.target.value)"
                            [(ngModel)]="selectedGroup"
                            >
                            <option value="">No Group</option>
                            @for (group of templateGroups; track group) {
                              <option [value]="group.id">
                                {{ group.name }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                  @if (profile.role == 'SuperVPlaybookAdmin') {
                    <div class="form-group">
                      <div class="row align-items-center">
                        <label class="control-label col-sm-4" for="companies"
                          >Companies</label
                          >
                          <div class="col-sm-8">
                            <select class="form-control" [formControl]="companies">
                              <option value="" selected="true">Select Companies</option>
                              <option value="-1">All Companies</option>
                              @for (company of nonSelectedCompanies; track company; let i = $index) {
                                <option [(ngValue)]="company.id">{{ company.name }}</option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    }
                    @if (selectedCompanies.length) {
                      <div>
                        <ul class="coversation-modal mt-4">
                          <li class="title">Title</li>
                          @for (company of selectedCompanies; track company) {
                            <li>
                              {{ company.name }}
                              <a
                                class="btn btn__white__inline pull-right"
                                (click)="removeCompany(company.id)"
                                >
                                <i class="material-icons blue-icon-color">delete</i>
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                    <div class="form-group">
                      <div class="row align-items-center">
                        <label for="" class="control-label col-sm-4"
                          >Include all page resources</label
                          >
                          <div class="col-sm-4">
                            <div class="btn-group btn__sm">
                              <label class="switch">
                                <input
                                  checked=""
                                  type="checkbox"
                                  [checked]="includeResources"
                                  (change)="includeResources = !includeResources"
                                  />
                                <span class="slider vPlaybookActiveToggle round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      @if (false) {
                        <div class="form-group">
                          <div class="row align-items-center">
                            <label for="" class="control-label col-sm-4">Include Languages</label>
                            <div class="col-sm-4">
                              <div class="btn-group btn__sm">
                                <label class="switch">
                                  <input
                                    checked=""
                                    type="checkbox"
                                    [checked]="includeLanguages"
                                    (change)="includeLanguages = !includeLanguages"
                                    />
                                  <span class="slider vPlaybookActiveToggle round"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </form>
                  </div>

                  <!-- Footer -->
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn vPlaybookDefaultButton btn__btn-default"
                      (click)="closeModal()"
                      >
                      Cancel
                    </button>
                    <button
                      id="pageResourceModalSaveButtonId"
                      class="btn btn__btn-default btn__orange"
                      style="color: white; margin: 0px 0px 0px 5px"
                      [ngClass]="{ 'custom-btn-disabled': templateForm.form.invalid }"
                      [disabled]="templateForm.form.invalid"
                      (click)="addPageTemplate(templateForm.form.valid)"
                      >
                      Save
                    </button>
                  </div>
                </div>
